import styled from "styled-components";

export default styled.div`
    .MuiBadge-badge {
        background-color: ${(props) => props.theme.subMenuBadgeBackground};
    }
`;
